import Header from "@/components/oneyork/Header";
import Hero from "@/components/oneyork/Hero";
import Services from "@/components/oneyork/Services";
import Gallery from "@/components/oneyork/Gallery";
import Reviews from "@/components/oneyork/Reviews";
import About from "@/components/oneyork/About";
import FAQ from "@/components/oneyork/FAQ";
import Contact from "@/components/oneyork/Contact";
import FloatingFeynlabBadge from "@/components/oneyork/FloatingFeynlabBadge";

export default function Home() {
  return (
    <main data-testid="home-page" className="bg-[#050505] text-white">
      <Header />
      <Hero />
      <Services />
      <Gallery />
      <Reviews />
      <About />
      <FAQ />
      <Contact />
      <FloatingFeynlabBadge />
    </main>
  );
}
